import { render, staticRenderFns } from "./SocialKeyTakeaways.vue?vue&type=template&id=edcb7814"
import script from "./SocialKeyTakeaways.vue?vue&type=script&lang=js"
export * from "./SocialKeyTakeaways.vue?vue&type=script&lang=js"
import style0 from "./SocialKeyTakeaways.vue?vue&type=style&index=0&id=edcb7814&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports